import { getDataLinkPath } from '../../../page/utils';
import useCloud from '../../../cloud';
import { useSelector } from 'react-redux';

const usePDF = () => {
  const { generatePdf } = useCloud();
  const user = useSelector(state => state.User);
  const { dataLinks } = useSelector(state => state.DataLinks);

  const generatePdfInCloud = async ({
    page,
    sequence,
    step,
    selections,
    documents,
    local,
    data,
    params
  }) => {
    if (
      !step.pdfTemplateId ||
      step.pdfTemplateId?.trim().length === 0 ||
      !step?.pdfDataLinkId
    ) {
      return {
        error: 'The step was not setup correctly and cannot run.'
      };
    } else if (!selections[step?.pdfDataLinkId]?.documentId) {
      return {
        error: `Cannot perform PDF generation as there is no selected document in data link with id ${step.pdfDataLinkId}`
      };
    }

    const pageDataLink = page.dataLinks.find(
      d => d.dataLinkId === step.pdfDataLinkId
    );

    if (!pageDataLink) {
      return {
        error: `sequence "${sequence.name}", step: ${step.name} cannot be processed because the data link with id ${step.pdfDataLinkId} set against the step cannot be found.`
      };
    }

    const path = getDataLinkPath({
      dataLink: pageDataLink.dataLink,
      documents,
      selections,
      user,
      local,
      dataLinks,
      data,
      params
    });

    const result = await generatePdf({
      templateId: step.pdfTemplateId,
      documentPath: `${path}/${selections[step.pdfDataLinkId].documentId}`,
      autoEmail: step.pdfTemplateAutoEmail || false
    });

    return result.data;
  };

  return {
    generatePdfInCloud
  };
};

export default usePDF;
